import React from 'react';
import { Select } from 'antd';
import { isNullOrUndefined } from '../../../helpers/helpers';

export const SOURCE_SELECTOR_MAX_WIDTH = 425 - 16; // parent is 425 and has 8px padding on both sides

export const getFieldSelectOptions = (fields) => (
  fields.map(({
    id, title, name, helpText,
  }) => (
    <Select.Option
      value={id}
      key={id}
    >
      {title || name}
      <div className="form-trigger-subtext">
        {helpText}
      </div>
    </Select.Option>
  ))
);

export function applyFieldMappingChange({
  fieldMappings,
  targetId,
  value,
  onFieldMappingsChange,
  formId,
}) {
  const newData = { ...fieldMappings };

  const isEmpty = isNullOrUndefined(value) || (Array.isArray(value) && value.length === 0);
  if (isEmpty) {
    delete newData[targetId];
  } else {
    newData[targetId] = value;
  }
  onFieldMappingsChange(newData, formId);
}
